import Loadable from '../../components/loadable';

const MembershipPaymentDateWarningModal = Loadable({
  loader: () => import('../../pages/memberships/membership_payment_date_warning_modal'),
  type: 'modal',
});

angular.module('gym').value('MembershipPaymentDateWarningModal', MembershipPaymentDateWarningModal);
